import React, { useState, useMemo } from 'react'
import { useBoardsContext } from '../context/BoardsContext'
import useBoardMutations from '../hooks/useBoardMutations'
import CollaboratorModal from './CollaboratorModal'
import BoardSettingsModal from './BoardSettingsModal'
import AutomationsModal from './AutomationsModal'

function BoardHeader() {
  const { currentBoard, canManage, selectedBoardId } = useBoardsContext()
  const { markBoardRead } = useBoardMutations(selectedBoardId)
  const [showCollaborators, setShowCollaborators] = useState(false)
  const [showSettings, setShowSettings] = useState(false)
  const [showAutomations, setShowAutomations] = useState(false)

  return (
    <>
      <div className="kb-header flex items-center justify-between mb-4">
        <div>
          {currentBoard && (() => {
            const totalUnseen = (currentBoard.columns || []).reduce((sum, col) => sum + (col.unseen_count || 0), 0)
            if (totalUnseen === 0) return null
            return (
              <button
                className="px-2 py-1 rounded-md text-xs font-semibold bg-yellow-100 text-yellow-800 hover:bg-yellow-200 focus:outline-none"
                onClick={() => markBoardRead.mutate()}
              >
                Clear {totalUnseen} new
              </button>
            )
          })()}
        </div>
        <div className="flex items-center space-x-4">
          {currentBoard && (
            <>
              <button className="link flex items-center" onClick={() => setShowCollaborators(true)}>
                <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" className="w-4 h-4 mr-1">
                  <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" />
                  <circle cx="9" cy="7" r="4" />
                  <path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75" />
                </svg>
                <span>Collaborators</span>
              </button>

              {canManage && (
                <>
                  <button className="link flex items-center" onClick={() => setShowAutomations(true)}>
                    <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" className="w-4 h-4 mr-1">
                      <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
                    </svg>
                    <span>Automations</span>
                  </button>
                  <button className="link flex items-center" onClick={() => setShowSettings(true)}>
                    <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" className="w-4 h-4 mr-1">
                      <path d="M12 15a3 3 0 100-6 3 3 0 000 6z" />
                      <path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z" />
                    </svg>
                    <span>Settings</span>
                  </button>
                </>
              )}
            </>
          )}
        </div>
      </div>

      {showCollaborators && (
        <CollaboratorModal onClose={() => setShowCollaborators(false)} />
      )}
      {showSettings && (
        <BoardSettingsModal onClose={() => setShowSettings(false)} />
      )}
      {showAutomations && (
        <AutomationsModal onClose={() => setShowAutomations(false)} />
      )}
    </>
  )
}

export default BoardHeader
